import { Icon } from '../../icon/icon';
import { ButtonStyle } from './button.style';

export function Button({ icon, size, color, onClick, theRef, ...props }: { icon: any; size?: number; color?: string; onClick?: () => void; theRef?: any }) {
  return (
    <ButtonStyle.Container ref={theRef} onClick={onClick} {...props}>
      <Icon icon={icon} size={(size ?? 16) + 'px'} color={color} />
    </ButtonStyle.Container>
  );
}
